import React, {
  forwardRef,
  useEffect,
  useState,
  useImperativeHandle,
  FC,
} from 'react';
import { Portal } from 'react-portal';
import { motion, AnimatePresence } from 'framer-motion';

import classNames from 'classnames';

import './modal.css'

type ModalProps = {
  ref?: any;
  children?: React.ReactNode;
  style?: object;
  id?: string;
}

export type ModalRef = {
  openModal?: any;
  closeModal?: any;
}

const Modal: FC<ModalProps> = forwardRef(({ children, id, style }, ref) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    return () => {

    }
  }, [])

  const openModal = () => {
    setShow(true)
  }

  const closeModal = (e) => {
    if (e && e.target && (e.target.classList.contains('modal_backdrop') || e.target.classList.contains('modal_close'))) {
      setShow(false)
    }
  }

  useImperativeHandle(ref, () => ({
    openModal: () => {
      setShow(true)
    },
    closeModal: () => {
      setShow(false)
    },
  }));

  return <Portal>
    <div aria-modal={true} aria-describedby="modal-desc" role="dialog">
      <div id={id} data-modal-backdrop className={show ? "modal_backdrop show" : "modal_backdrop"} onClick={closeModal}>
        <div className={classNames("modal_wrapper")} style={style}>
          <div className="modal_content">
            <p id="modal-desc" hidden="hidden">Form modal</p>
            {children}
          </div>
        </div>
        <button className="modal_close" onClick={closeModal}>
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"><path d="M11.192 9.071l7.779-7.778a1.5 1.5 0 0 1 2.12 2.121l-7.777 7.778 7.778 7.779a1.5 1.5 0 1 1-2.121 2.12l-7.779-7.777-7.778 7.778a1.5 1.5 0 1 1-2.121-2.121l7.778-7.779-7.778-7.778a1.5 1.5 0 0 1 2.121-2.121l7.778 7.778z" fill="#FFF" fill-rule="nonzero"></path></svg>
        </button>
      </div>
    </div>
  </Portal>
});

export default Modal